<template>
    <v-card>
        <v-card-text>
            <h3 class="mb-5">{{ $t('editUserInformation.changePassword') }}</h3>
            <form>
                <v-text-field
                    v-model="formData.oldPassword"
                    :error-messages="oldPasswordErrors"
                    :label="$t('editUserInformation.passwordForm.oldPassword')"
                    type="password"
                    required
                    autocomplete="current-password"
                    @keyup="clearServerErrors('oldPassword')"
                    @input="$v.formData.oldPassword.$touch()"
                    @blur="$v.formData.oldPassword.$touch()"
                />
                <v-text-field
                    v-model="formData.newPassword"
                    :error-messages="newPasswordErrors"
                    :label="$t('editUserInformation.passwordForm.newPassword')"
                    type="password"
                    required
                    autocomplete="new-password"
                    @keyup="clearServerErrors('newPassword')"
                    @input="$v.formData.newPassword.$touch()"
                    @blur="$v.formData.newPassword.$touch()"
                />
                <v-text-field
                    v-model="formData.newPasswordRepeat"
                    :error-messages="newPasswordRepeatErrors"
                    :label="
                        $t('editUserInformation.passwordForm.newPasswordRepeat')
                    "
                    type="password"
                    required
                    autocomplete="new-password"
                    @keyup="clearServerErrors('newPasswordRepeat')"
                    @input="$v.formData.newPasswordRepeat.$touch()"
                    @blur="$v.formData.newPasswordRepeat.$touch()"
                />
                <v-card-actions>
                    <v-spacer />
                    <v-btn depressed @click="submit">
                        {{ $t('editUserInformation.passwordForm.submit') }}
                    </v-btn>
                </v-card-actions>
            </form>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import changePasswordValidator from '@/validators/users/changePasswordValidator.mixin.js';

export default {
    name: 'profileNewPasswordForm',

    mixins: [changePasswordValidator],

    data() {
        const defaultFormData = {
            oldPassword: '',
            newPassword: '',
            newPasswordRepeat: ''
        };

        return {
            formData: {
                ...defaultFormData
            },
            defaultFormData
        };
    },

    methods: {
        ...mapActions({ saveNewPassword: 'auth/saveNewPassword' }),

        async submit() {
            try {
                this.$v.$touch();

                if (!this.isValid) {
                    return;
                }

                await this.saveNewPassword(this.formData);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('editUserInformation.success.title'),
                    text: this.$t(
                        'editUserInformation.success.passwordChangeText'
                    )
                });

                this.formData = { ...this.defaultFormData };
                this.$v.$reset();
            } catch (error) {
                if (this.checkForServerFormErrors(error)) {
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t('editUserInformation.fail.title'),
                        text: this.$t(
                            'editUserInformation.fail.passwordChangeText'
                        )
                    });
                }

                console.error(error);
            }
        }
    }
};
</script>
